import { render, staticRenderFns } from "./AboutCardMtByAlfa.vue?vue&type=template&id=48971b23"
import script from "./AboutCardMtByAlfa.vue?vue&type=script&lang=js"
export * from "./AboutCardMtByAlfa.vue?vue&type=script&lang=js"
import style0 from "../about-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports